import { requiredLabel } from 'utils/form';
import { FieldVariant } from 'generated/graphql';
import FileUploader from '../../FileUploader';
import ImageUploadField, { ImageUploadFieldVariant } from '../../ImageUploader/ImageUploadField';
import type { FieldRendererProps } from '../types';

export function FileImageUploadField({
  field,
  fieldGroup,
  fieldIndex = 0,
  isHorizontal,
  isQCStorage,
  formType,
  isDisabled,
  onChange,
}: FieldRendererProps) {
  const files = field.values?.length > 0 ? field.values : field.value.split(';').filter(Boolean);
  const handleChange = (values: string[]) => {
    onChange(values.join(';'), values);
  };

  if (isHorizontal) {
    return (
      <ImageUploadField
        label={requiredLabel(field.label, field.required)}
        hasWhiteFields={false}
        files={files}
        onChange={handleChange}
        relatedField={fieldGroup[fieldIndex - 1]?.value}
        id={field.id.toString()}
        disabled={isDisabled}
        uploadFolder={field.uploadFolder ?? undefined}
        acceptedFileTypes={field.acceptedFileTypes ?? undefined}
        variant={
          field.variant === FieldVariant.Detailed ? ImageUploadFieldVariant.Button : ImageUploadFieldVariant.Default
        }
      />
    );
  }

  return (
    <FileUploader
      label={requiredLabel(field.label, field.required)}
      files={files}
      onChange={handleChange}
      isQCStorage={isQCStorage}
      formType={formType}
      id={field.id.toString()}
      disabled={isDisabled}
      uploadFolder={field.uploadFolder ?? undefined}
      acceptedFileTypes={field.acceptedFileTypes ?? undefined}
    />
  );
}
